module.exports = __webpack_public_path__ + "onboarding-targettypes.e3b851682d2e1f3369a80620ca80dda0.hashedasset.svg";